<template>
  <div class="kidy-box">
	<div class="kidy-box-container">
		<div class="kidy-box-top">
			<img src="../../assets/image/tianjia_20@2x.png" alt="" @click="handleAdd" />
			<span>{{$t('all.kuaijieduanyu')}}</span>
			<img src="../../assets/image/tanchuang_x_b@2x.png" alt="关闭" @click="handleClose" />
		</div>
		<div class="kidy-box-list">
			<div class="kidy-box-list-item" v-for="(item,index) in list" :key="index">
				<div class="kidy-box-list-item-left">{{item.content}}</div>
				<img src="../../assets/image/x_22_1@2x.png" alt="" @click="delLiveCommonExpressions(item.id)" />
			</div>
			<kong v-if="isKong"/>
		</div>
		<div v-if="isKjdyModel" class="kjdy-mask"></div>
		<div class="kjdy-mask-model" v-if="isKjdyModel" @click="isKjdyModel = false">
			<div class="kjdy-mask-model-rect" @click.stop>
				<div class="kjdy-mask-model-rect-title">{{$t('all.xinzengkuaijieduanyu')}}</div>
				<input v-model="content" type="text" :placeholder="$t('all.qingshuru')"/>
				<div class="kjdy-mask-model-rect-btn" @click="addLiveCommonExpressions">{{$t('all.tijiao')}}</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import kong from "../kong/kong.vue";
import { getLiveCommonExpressionsList,addLiveCommonExpressions,delLiveCommonExpressions } from "@/api/zhibo";
export default {
  components: {
    kong
  },
  data() {
    return {
	  list:[],
	  isKong:false,
	  isKjdyModel:false,
	  content:''
    };
  },
  mounted() {
	this.getLiveCommonExpressionsList()
  },
  methods: {
	//常用语列表
	async getLiveCommonExpressionsList(){
		const res = await getLiveCommonExpressionsList({liveId:this.$route.query.liveId})
		this.list = res.data
		if(this.list.length > 0){
			this.isKong = false
		}else{
			this.isKong = true
		}
	},
	//添加
	handleAdd(){
		this.isKjdyModel = true
		this.content = ''
	},
	//关闭
	handleClose(){
		this.$emit('close_kjdy')
	},
	//确定添加快捷短语
	async addLiveCommonExpressions(){
		const params = {
			content:this.content,
			liveId:this.$route.query.liveId
		}
		const res = await addLiveCommonExpressions(params)
		this.isKjdyModel = false
		this.getLiveCommonExpressionsList()
	},
	//删除快捷短语
	async delLiveCommonExpressions(id){
		const params = {
			id:id,
			liveId:this.$route.query.liveId
		}
		const res = await delLiveCommonExpressions(params)
		this.getLiveCommonExpressionsList()
	},

  }
};
</script>
<style scoped lang="scss">
	@import "./kuaijieduanyu.css";
</style>


// WEBPACK FOOTER //
// kuaijieduanyu.vue?104f7132